import { Spacing } from '@persona-id/design-tokens';
import { FC } from 'react';
import styled from 'styled-components';

import { VersionDiffChangeType } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateVisualVersionDiff/types';
import Sticker from 'design-system/components/Sticker';
import { Variant } from 'design-system/theme';
import { assertNever } from 'lib/utils/types';

const StickerWrapper = styled.div`
  width: ${Spacing[9]};
`;

const DiffStatusSticker: FC<{ changeType: VersionDiffChangeType }> = ({ changeType }) => {
  const getStickerStatus = (): [Exclude<Variant, 'basic' | 'inverse' | 'primary'>, string] => {
    switch (changeType) {
      case VersionDiffChangeType.ADDED: {
        return ['success', 'New'];
      }
      case VersionDiffChangeType.MODIFIED: {
        return ['caution', 'Modified'];
      }
      case VersionDiffChangeType.REMOVED: {
        return ['danger', 'Removed'];
      }
      default:
        assertNever(changeType);
    }
  };
  const [stickerVariant, label] = getStickerStatus();
  return (
    <StickerWrapper>
      <Sticker variant={stickerVariant}>{label}</Sticker>
    </StickerWrapper>
  );
};

export default DiffStatusSticker;
